import L, { popup } from "leaflet";
import "./index.js";
import china from "./china.json";
import normal from "./ditu.js";
import legendColor from "./legendColor.json";
// import legendVue from "@/page/legend.vue";
import mapimg from "@/assets/map/mapExport.js";
// import { color } from "echarts";
import { map } from "lodash";
// import EasyPrint from "leaflet-easyprint";
import "./Leaflet.Editable.js";
class MapCreate {
  constructor(map, mapData, mapLegend, mapLegendData) {
    this.map = null;
    // this.mapData = mapData;
    // this.mapLegend = mapLegend;
    // this.mapLegendData = mapLegendData;
  }
  init(idname) {

    this.map = L.map(idname, {

      center: [29, 100],  // 初始中心点
      zoom: 6.5,  // 初始化地图缩放级别
      minZoom: 1, //最小级别
      maxZoom: 14,  //最大缩放级别
      zoomSnap: 0.5, //强制让地图的缩放级别始终为这个值的倍数
      zoomDelta: 0.5, //地图缩放级别改变的值
      doubleClickZoom: false, //双击放大
      layers: [normal.Gaode], //添加图层
      zoomControl: false, //是否显示缩放控件
      attributionControl: false,  //是否显示右下角的attribution
      wheelPxPerZoomLevel: 300, //较小的值将使滚轮变焦更快 多少滚动像素
      editable: true,
      preferCanvas: true
    });
    // L.Popup.prototype._animateZoom = function (e) {
    //   if (!this._map) {
    //     return;
    //   }
    //   var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
    //     anchor = this._getAnchor();
    //   L.DomUtil.setPosition(this._container, pos.add(anchor));
    // };
    //地图切换控件 img设置
    // const vector = `<img class='my-layer-img' src='${mapimg.vector}' /> `;
    // const satellitepoi = `<img class='my-layer-img' src='${mapimg.satellitepoi}' /> `;
    // const terrain = `<img class='my-layer-img' src='${mapimg.terrain}' /> `;
    // //新建图层控件的数据源-地图
    // const baseLayers = {
    //   [vector]: normal.Gaode,
    //   [satellitepoi]: normal.image,
    //   [terrain]: normal.terrain,
    // };

    // const layerControl = L.control.layers(baseLayers).addTo(this.map);
    // //地图切换控件 img设置
    // layerControl._baseLayersList.style.display = "flex";
    // layerControl._baseLayersList.querySelectorAll("label").forEach((item) => {
    //   item.style.position = "relative";
    //   item.style.marginLeft = "5px";
    //   item.querySelector("input").style.cssText =
    //     "position:absolute;top:0;z-index:1; ";
    // });
    // const style = {
    //   color: "#000", //线颜色
    //   weight: 2, //线粗细
    //   opacity: 1, //透明度
    //   fillColor: "#fff", //区域填充颜色
    //   fillOpacity: 0, //区域填充颜色的透明
    // };
    // L.geoJSON(china.features, { style: style }).addTo(this.map);

    return this.map
  }

  mapBorder() {
    //铁路线路
    const Lon = [103.977, 103.4974, 103.0555, 101.963, 100.2901, 97.8408, 95.7676, 94.3636, 91.1377,];
    const Lat = [30.678, 30.1893, 30.0262, 30.0538, 29.9833, 29.6709, 29.859, 29.6421, 29.6526,];
    let data = [];
    Lon.forEach((element, index) => {
      data.push([Lat[index], element]);
    });
    L.polyline(data, {
      color: "black",
      weight: 2,
      className: "dashLines",
    }).addTo(this.map);
    /* 这里分为两个写是因为，层级问题 */
    Lon.forEach((element, index) => {
      L.circleMarker(new L.LatLng(...data[index]), {
        // 创建点 (38, 107)为经纬度
        color: "#0302f1", //线颜色
        weight: 2, //线宽度
        opacity: 1, //透明度
        fillColor: "#0302f1", //填充色
        fillOpacity: 1, //填充透明度
        radius: 5, //半径
      }).addTo(this.map);
    });
    let bounds = [[28, 106], [32, 89],];
    // 创建一个蓝色色的矩形
    L.rectangle(bounds, {
      // color: "#0302f1",
      color: "#0302f1",
      weight: 3,
      fillColor: "#fff",
      fillOpacity: 0,
    }).addTo(this.map);

    // map.fitBounds(bounds);
    //显示文字
    const leftposition = [[28, 89,], [29, 89,], [30, 89,], [31, 89,], [32, 89,], [28, 90], [28, 91], [28, 92], [28, 93], [28, 94], [28, 95], [28, 96], [28, 97], [28, 98], [28, 99], [28, 100], [28, 101], [28, 102], [28, 103], [28, 104], [28, 105], [28, 106]];
    // console.log(leftposition);
    leftposition.forEach((res, index) => {
      // console.log(res);
      if (index < 5) {
        const myIcon = L.divIcon({
          className: "NrectangleLatlng",
          html: `<div>${res[0]}°N</div>`,

        });
        L.marker([res[0], res[1] - 0.5], { icon: myIcon }).addTo(this.map);
      } else {
        const myIcon = L.divIcon({
          className: "ErectangleLatlng",
          html: `<span>${res[1]}°E</span>`,
        });
        L.marker(res, { icon: myIcon }).addTo(this.map);
      }


    });
    let t = this
    this.map.on('zoomend', function () {

      // var newzoom = '' + (20*(map.getZoom()+2)) +'px';
      let myIconList = document.querySelectorAll(".ErectangleLatlng")
      // console.log(myIconList);
      myIconList.forEach((item) => {
        item.style.fontSize = `${t.map.getZoom() * 2}px`
      })

      let myIconList2 = document.querySelectorAll(".NrectangleLatlng")
      // console.log(myIconList);
      myIconList2.forEach((item) => {
        item.style.fontSize = `${t.map.getZoom() * 2}px`
      })


    });
  }
}
export {
  L,
  legendColor,
  // legendVue,
  mapimg,
  MapCreate
};
